const state = {
    profile: {},
};

const getters = {
  profile: () => state.profile,
};

const actions = {};

const mutations = {
  PROFILE({}, profile) {
    state.profile = profile;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
